import {FC, useState, useEffect, Fragment} from 'react'
import Table from 'react-bootstrap/Table'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import useServices from '../../../../../utils/hooks/useServices'
import useDebounce from '../../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../../services/master'
import FormModal from './FormModal'

import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

const api = new Api()
const heads = [
  {
    name: '',
    label: 'Komponen',
  },
  {
    name: '',
    label: 'Bobot (%)',
  },
  {
    name: '',
    label: 'Tipe',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const IndicatorAssessmentPage: FC = () => {
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const [show, setShow] = useState(false)
  const [showModule, setShowModule] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({})
  const [loading, setLoading] = useState<any>(false)

  const [data, setData] = useState<any>({})

  const paginator: any = usePagination({
    totalCount: data?.data?.total || 0,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchData()
  }, [query])

  useEffect(() => {
    fetchData()
  }, [pagination.per_page, pagination.page])

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleClose = (isShow: boolean) => {
    setFormValue({})
    setShow(isShow)
    fetchData()
  }

  const handleCloseModule = (isShow: boolean) => {
    setShowModule(isShow)
  }

  const fetchData = () => {
    setLoading(true)
    api
      .getDetailAssessmentAdmin({
        ...query,
        page: pagination.page,
        sort_field: 'created_at',
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        setLoading(false)
        const data = response.data
        setData(data)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const deleteData = (id: any) => {
    setLoading(true)
    api
      .deleteDetailAssessment(id)
      .then((response: any) => {
        setLoading(false)
        toast.success(response?.data?.meta?.message)
        fetchData()
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const handleDelete = async (id: any) => {
    if (!window.confirm('Yakin ingin menghapus data?')) {
      return
    }

    deleteData(id)
  }

  return (
    <>
      <FormModal showFormModal={show} handleCloseFormModal={handleClose} formData={formValue} />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <Row>
              <Col md={{span: 4}}>
                <input
                  type='text'
                  onChange={(e) => {
                    setPagination({...pagination, per_page: pagination.per_page, page: 1})
                    setQuery({...query, q: e.target.value})
                  }}
                  className='form-control'
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <button
                  type='button'
                  onClick={() => setShow(true)}
                  className='form-control btn btn-primary'
                >
                  + Tambah
                </button>
              </Col>
              <Col md={{span: 2}}>
                <select
                  aria-label='Default select example'
                  className='mr-8 form-control'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </select>
              </Col>
            </Row>{' '}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>#</th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.data?.map((item: any, key: any) => {
                    return (
                      <tr key={key}>
                        <td>{(pagination?.page - 1) * pagination?.per_page + key + 1}</td>
                        <td>{item.nama}</td>
                        <td>{`${item.bobot}%`}</td>
                        <td>{item.tipe}</td>
                        <td>
                          <button
                            type='button'
                            className='btn btn-primary btn-sm me-2'
                            onClick={() => {
                              setFormValue(item)
                              setShow(true)
                            }}
                          >
                            Edit
                          </button>

                          <button
                            type='button'
                            className='btn btn-danger btn-sm me-2'
                            onClick={() => handleDelete(item?.id)}
                          >
                            Hapus
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && paginator.pageCount > 1 && (
                    <Pagination className='btn-sm'>
                      <Pagination.Prev
                        disabled={pagination.page === 1}
                        onClick={() => onChangePerPage(pagination.per_page, pagination.page - 1)}
                      />
                      {paginator.pages.map((page: any) => (
                        <Pagination.Item
                          className='btn-sm'
                          key={page}
                          active={page === pagination.page}
                          onClick={() => onChangePerPage(pagination.per_page, page)}
                        >
                          {page}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        disabled={pagination.page === paginator.pageCount}
                        onClick={() => onChangePerPage(pagination.per_page, pagination.page + 1)}
                      />
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const IndicatorAssessment: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Indikator Penilaian
      </PageTitle>
      <IndicatorAssessmentPage />
    </>
  )
}

export default IndicatorAssessment
